import { Button, ButtonsGroup, InputText, Typo } from "#/atoms";
import { FC, memo, useCallback, useEffect, useState } from "react";

import { DESKTOP_SPACING } from "@/theme";
import { Modal } from "#/molecules";
import { VirtualTourSurchargeProps } from "./VirtualTourSurcharge.interface";
import { useApi } from "@/api";
import { useInput } from "@/hooks";

const VirtualTourSurcharge: FC<VirtualTourSurchargeProps> = ({ onClose, onConfirm, virtualTourPhotos }) => {
  const [description, setDescription] = useState('A surcharge of £%amount% per image applies above %threshold%');
  const { settings } = useApi();
  const virtualTourPhotosInput = useInput(virtualTourPhotos.toString());

  const handleConfirm = () => {
    onConfirm(virtualTourPhotosInput.value ? Number(virtualTourPhotosInput.value) : 0);
    onClose();
  };

  const getSettings = async () => {
    await settings.get();
  }

  useEffect(() => {
    getSettings().then(
      () => {
        setDescription(description.replace('%amount%', (settings.settings?.virtualTourImagesSurchargeAmount ?? 0).toString())
        .replace('%threshold%', (settings.settings?.virtualTourImagesThreshold ?? 0).toString()));
      }
    );
  }, []);

  return (
    <Modal onClose={onClose} title="Add surcharge">
      <Typo>{description}</Typo>
      <InputText type="text" label="Virtual Tour Photos" value={virtualTourPhotosInput.value} onChange={virtualTourPhotosInput.onChange}></InputText>
      <ButtonsGroup fullWidth margin={`${DESKTOP_SPACING.EL}px 0 0`}>
        <Button onClick={handleConfirm}>Add</Button>
        <Button onClick={onClose}>Cancel</Button>
      </ButtonsGroup>
    </Modal>
  );
};

export default memo(VirtualTourSurcharge);